import React, { useState, useEffect } from "react";
import { baseUrl } from "../../../services/config";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useAlert } from "react-alert";
import SVG from "react-inlinesvg";
import { Table, Modal, Alert } from "react-bootstrap";
import Paper from "@material-ui/core/Paper";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

export default function BranchesUrl() {
  const history = useHistory();
  const alert = useAlert();
  const dispatch = useDispatch();
  const authtoken = localStorage.getItem("userToken");

  // let [hostels, sethostels] = useState(useSelector(state => state.hostel.hostels))
  let [hostels, sethostels] = useState([]);
  const user = useSelector((state) => state.user.user);
  const [loading, setloading] = useState(false);
  const [addModal, setaddModal] = useState(false);
  const [name, setname] = useState("");
  const [address, setaddress] = useState("");
  const [address_2, setaddress_2] = useState("");
  const [name1, setname1] = useState("");
  const [selectedId, setselectedId] = useState("");
  const [longitude, setlongitude] = useState("");
  const [addLoading, setaddLoading] = useState(false);
  const [Current, setCurrentId] = useState("");
  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteLoading, setdeleteLoading] = useState(false);
  const [editModal, seteditModal] = useState(false);
  const [selectedHostel, setselectedHostel] = useState({});
  const [add_hostel_check, setadd_hostel_check] = useState(false);
  const [selectedhostelindex, setselectedhostelindex] = useState();
  const [campusData, setCampusData] = useState(user.campuses || []);
  const [campusId, setCampusId] = useState("");
  const [campusError, setCampusError] = useState(false);

  useEffect(() => {
    getAllHostels();
    // getAllCampus();
  }, []);

  const getAllCampus = async () => {
    await fetch(`${baseUrl}/campus`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setCampusData(data.payload);
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };
  const getAllHostels = async () => {
    setloading(true);
    fetch(`${baseUrl}/view-branch-url`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((allhostels) => {
        console.log(allhostels, "allhostels");
        dispatch({
          type: "GET_ALL_HOSTELS",
          payload: allhostels.payload,
        });
        sethostels([...allhostels.payload]);
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
        console.log(err);
      });
  };

  const handleSubmit = () => {
    if (name == "") {
      alert.error("Enter Branch Name");
      return;
    }
    const data = {
      branch_name: name,
      branch_url: address,
    };
    setaddLoading(true);
    fetch(`${baseUrl}/add-new-branch-url`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            setaddLoading(false);
            setaddModal(false);
            getAllHostels();
            alert.show("Brach Added Successfully");
          }
        })
      )
      .catch((err) => {
        console.log(err);
        setaddLoading(false);
        setaddModal(false);
      });
  };
  const handleUpdate = () => {
    if (name1 == "") {
      alert.error("Enter Branch Name");
      return;
    }
    const data = {
      id: selectedId,
      branch_name: name1,
      branch_url: address_2,
    };
    setaddLoading(true);
    fetch(`${baseUrl}/update-branch-url`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.show("Brach Updated Successfully");
            setaddLoading(false);
            seteditModal(false);
            getAllHostels();
          }
        })
      )
      .catch((err) => {
        console.log(err);
        setaddLoading(false);
        setaddModal(false);
      });
  };

  const deleteMiddle = (id) => {
    setCurrentId(id);
    setdeleteModal(true);
  };

  const DeleteHostelHandler = () => {
    console.log(Current);
    setdeleteLoading(true);
    setaddLoading(true);
    // const data = {
    //   id: Current,
    // };
    fetch(`${baseUrl}/delete-branch-url?id=${Current}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      //   body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          setdeleteModal(false);
          alert.success("Deleted Successfully");
          setdeleteLoading(false);
          getAllHostels();
        }
      })
      .catch((err) => {
        setdeleteModal(false);
        setdeleteLoading(false);
        console.log(err);
      });
  };
  const middleUrlFunc = (url) => {
    // Construct the URL you want to open in a new tab/window
    // const editUrl = `/edit/${id}`; // Example URL format

    // Open the URL in a new tab/window
    window.open(url, "_blank");
  };

  const middleEditFunc = (hostel, index) => {
    if (!Array.isArray(hostels)) {
      console.error("hostel is not an array");
      return;
    }
    console.log(index);
    setselectedId(index);
    const filteredData = hostels.filter((item) => item.id === index);

    console.log(filteredData);
    setname1(filteredData[0]?.branches);
    setaddress_2(filteredData[0]?.branch_url);
    // setselectedhostelindex(index);
    // setselectedHostel(hostel);
    seteditModal(true);
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "15px", padding: "15px", marginBottom: "15px" }}
      >
        <button
          className="btn btn-success button_blue"
          onClick={() => setaddModal(true)}
        >
          Add Branch{" "}
        </button>
        <br />
        <br />
        <Table>
          <thead>
            <tr className="text-center">
              <th style={{ textAlign: "center" }}>Sr.#</th>
              <th style={{ textAlign: "start" }}>Branch Name</th>
              <th style={{ textAlign: "start" }}>Link</th>
              <th style={{ textAlign: "center" }}>View</th>
              <th style={{ textAlign: "center" }}>Edit</th>
              <th style={{ textAlign: "center" }}>Delete</th>
            </tr>
          </thead>
          <tbody>
            {hostels.map((item, index) => (
              <>
                <tr key={item.id}>
                  <td style={{ textAlign: "center" }}>{index + 1}</td>
                  <td style={{ textAlign: "start" }}>{item.branches}</td>
                  <td style={{ textAlign: "start" }}>{item.branch_url}</td>
                  <td style={{ textAlign: "center" }}>
                    <span
                      onClick={() => middleUrlFunc(item.branch_url)}
                      style={{ cursor: "pointer" }}
                      className="svg-icon svg-icon-md svg-icon-primary"
                    >
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Devices/Display2.svg"
                        )}
                      />
                    </span>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <span
                      onClick={() => middleEditFunc(item, item.id)}
                      style={{ cursor: "pointer" }}
                      className="svg-icon svg-icon-md svg-icon-primary"
                    >
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Write.svg"
                        )}
                      />
                    </span>
                  </td>

                  <td style={{ textAlign: "center" }}>
                    <span
                      onClick={() => deleteMiddle(item.id)}
                      style={{ cursor: "pointer" }}
                      className="svg-icon svg-icon-md svg-icon-danger"
                    >
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/Trash.svg"
                        )}
                      />
                    </span>
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </Table>

        <div style={{ marginLeft: 400 }}>
          {loading && <span className="spinner-border"></span>}
        </div>

        <Modal show={addModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add New Branch
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div>
              <div className="row">
                <div className="col-md-6">
                  <label>
                    Branch Name <span style={{ color: "red" }}>*</span>
                  </label>

                  <input
                    placeholder="Enter Branch Name"
                    className="form-control"
                    onChange={(e) => setname(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <label>
                    Branch Address <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="form-control"
                    onChange={(e) => setaddress(e.target.value)}
                    placeholder="Enter Branch Url Address"
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-success button_blue"
              //  onClick={AddHostelHandler}
              onClick={handleSubmit}
            >
              Add Branch
            </button>
            <button
              className="btn btn-danger btn_width"
              onClick={() => setaddModal(false)}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        <Modal show={deleteModal}>
          <Modal.Header>Delete Branch</Modal.Header>
          <Modal.Body>
            {deleteLoading ? (
              <b style={{ color: "green" }}>
                Branch Deleting Please wait {` `}{" "}
                <span className="spinner-border"></span>
              </b>
            ) : (
              <>Are you sure you want to delete?</>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-danger btn_width"
              onClick={DeleteHostelHandler}
            >
              Delete
            </button>
            <button
              className="btn  btn-primary btn_width"
              onClick={() => setdeleteModal(false)}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        <Modal show={editModal} size="lg">
          {/* <Modal.Header>Edit Hostel</Modal.Header> */}
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Update Branch
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="row">
                <div className="col-md-6">
                  <label>
                    Branch Name <span style={{ color: "red" }}>*</span>
                  </label>

                  <input
                    placeholder="Enter Branch Name"
                    className="form-control"
                    onChange={(e) => setname1(e.target.value)}
                    defaultValue={name1}
                  />
                </div>
                <div className="col-md-6">
                  <label>
                    Branch Address <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="form-control"
                    onChange={(e) => setaddress_2(e.target.value)}
                    placeholder="Enter Branch Address"
                    defaultValue={address_2}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-success button_blue"
              //  onClick={AddHostelHandler}
              onClick={handleUpdate}
            >
              Update
            </button>
            <button
              className="btn btn-danger btn_width"
              onClick={() => seteditModal(false)}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </Paper>
    </div>
  );
}
